import React from 'react'

export default class Dashboard extends React.Component {
    render() {
        return (
            <p>Partner Dashboard</p>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Partner/Dashboard/Dashboard.jsx